import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { getInstallStatAll } from "../../../service/monitor/installStatusService";
import { getInstallDataTest } from "../../../service/monitor/installStatus_test";
import ElderInfoList from "./elderInfoList";
import { ElderInfoWindow } from "./elderInfoWindow";
import { BeatLoader } from "react-spinners";
import kendo from "@progress/kendo-ui";

// CSS
import "./installStatus.css";
import styles from "./installStatus.module.css";
import { getUser, isAdmin, isUser } from "../../../service/authService";
import { setUpdateUserNote } from "../../../service/monitor/allStatusService";

const InstallStatus = ({ conn, rgnList, dongList }) => {
  const [loading, setLoading] = useState(false);
  // 테스트 버전 여부
  const isTest = true;
  // 카카오 적용
  const { kakao } = window;
  // 맵 레벨 설정
  const DEFAULT_MAP_LEVEL = 12;
  const history = useHistory();
  const AREA_CITY = "CITY";
  const AREA_RGN = "RGN";
  const AREA_DONG = "DONG";
  let DEFAULT_LATI = 36.81508; //위도
  let DEFAULT_LONGI = 127.11392; //경도

  rgnList.map(item => {
    if(item.rgnCode === getUser().rgnCode) {
      DEFAULT_LATI = item.lati
      DEFAULT_LONGI = item.longi
    }
  })

  // 검색 조건
  const [search, setSearch] = useState({
    userId: "",
    rgnCode: getUser().rgnCode,
    dongCode: "",
    meainStatCode: "",
    lati: DEFAULT_LATI,
    longi: DEFAULT_LONGI,
    mapLevel: DEFAULT_MAP_LEVEL,
    mapAddressCode: "",
    cityProvCode: "",
    cityProvTerm: "",
    mapLevelTerm: "전체 시도별",
    type: AREA_CITY,
    dong: { dongCode: "", dongTermSimple: "읍면동" },
  });

  // 맵
  const [map, setMap] = useState("");

  // 지도에 표시된 마커 객체
  let markers = useRef([]);

  // 마커 이벤트 배열
  let markerHandler = useRef([]);

  // 데이터 리스트
  const [dataSource, setDataSource] = useState([]);
  
  const loadMap = (lati, longi, dongCode) => {
    // 맵 설정
    const map = new kakao.maps.Map(document.getElementById("locaitonMap"), {
      //지도를 생성할 때 필요한 기본 옵션
      center: new kakao.maps.LatLng(lati, longi), //지도의 중심좌표.
      level: 4, //지도의 레벨(확대, 축소 정도)
    });
    setMap(map);
    getInfoData(map, dongCode)
  }
  // 데이터 불러오기
  const getInfoData = (map, dongCode) => {
    setLoading(true);
    search.dongCode = dongCode;
    getInstallStatAll(conn, search)
      .then(response => {
        response.forEach(item => {
          item.map = map;
        });
        setDataSource(response);
        setMarker(map, response);
        setLoading(false);
      })
      .catch(error => console.log("getInstallStatAll Error", error));
  };

  // 마커 찍기
  const setMarker = (map, elderInfoList) => {
    removeMarkers();

    // 전체 데이터 가져와서 마커 찍기
    elderInfoList.forEach(elderInfo => {
      // 마커이미지의 주소입니다
      let imageSrc = "";
      if (elderInfo.meainStatCode === "20001") {
        imageSrc = "/images/chncareweb/marker_normal.png";
      } else if (elderInfo.meainStatCode === "20002") {
        imageSrc = "/images/chncareweb/marker_warn.png";
      } else if (elderInfo.meainStatCode === "20003") {
        imageSrc = "/images/chncareweb/marker_off.png";
      } else if (elderInfo.meainStatCode === "20004") {
        imageSrc = "/images/chncareweb/marker_danger.png";
      } else {
        imageSrc = "/images/chncareweb/marker_off.png";
      }

      //경도,위도 null값 예외처리
      if (!elderInfo.lat || !elderInfo.lng) return;
      const marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(parseFloat(elderInfo.lat), parseFloat(elderInfo.lng)),
        image: new kakao.maps.MarkerImage(imageSrc, new kakao.maps.Size(20, 32), { offset: new kakao.maps.Point(16.5, 32) }), // 마커이미지 설정
        clickable: true,
      });

      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);
      markers.current.push(marker);

      // 마우스 오버 콘텐츠
      const overWindow = new kakao.maps.InfoWindow({
        content: '<div class="kakaoMapMouseOverDiv">' + elderInfo.userTerm + "</div>",
      });

      // 마커 마우스 오버 인 이벤트
      const mouseOverEvt = () => {
        overWindow.open(map, marker);
      };
      kakao.maps.event.addListener(marker, "mouseover", mouseOverEvt);

      // 마커 마우스 오버 아웃 이벤트
      const mouseOutEvt = () => {
        overWindow.close();
      };
      kakao.maps.event.addListener(marker, "mouseout", mouseOutEvt);

      // 마커 클릭 콘텐츠
      const infoWindow = new kakao.maps.InfoWindow({
        // position : new kakao.maps.LatLng(elderInfo.lati, elderInfo.longi),
        content: ElderInfoWindow(elderInfo),
      });

      // 인포윈도우 위치 설정 왜그런지 모르겠지만 Qd, Nd 랜덤으로 뜸
      if (infoWindow.Qd) {
        infoWindow.Qd.width = -6.5;
        infoWindow.Qd.height = -3;
      } else if (infoWindow.Nd) {
        infoWindow.Nd.width = -6.5;
        infoWindow.Nd.height = -3;
      }

      // 마커 클릭 이벤트
      const clickMarker = () => {
        if (document.getElementsByName("closeInfoBtn")[0]) document.getElementsByName("closeInfoBtn")[0].click();
        const level = map.getLevel() >= 3 ? 3 : map.getLevel();
        map.setLevel(level);
        infoWindow.open(map, marker);
        createInfoWindow(map, marker, infoWindow, elderInfo);
        setMapPosition(parseFloat(elderInfo.lat), parseFloat(elderInfo.lng), map);
      };

      // 맵 클릭 이벤트
      kakao.maps.event.addListener(marker, "click", clickMarker);
    });
  };

  // infoWindow 창 제작
  const createInfoWindow = (map, marker, infowindow, element) => {
    infowindow.open(map, marker);
    //닫기(x) 버튼
    const closeBtn = document.getElementsByName("closeInfoBtn")[0];
    closeBtn.addEventListener("click", function () {
      infowindow.close();
    });

    //특이사항 수정 버튼
    const modifyBtn = document.getElementById("noteModiBtn");
    modifyBtn.addEventListener("click", function () {
      const elderInfoNote = document.getElementById("elderInfoNote");
      const dataItem = {
        userId: elderInfoNote.name,
        note: elderInfoNote.value,
      };
      kendo.confirm("특이사항을 수정하시겠습니까?").then(() => {
        setUpdateUserNote(conn, dataItem)
          .then(response => kendo.alert("수정완료"))
          .catch(error => console.log("특이사항 업데이트 오류", error));
      });
    });

    const moveInstaller = document.getElementsByName("informationBtn")[0];
    moveInstaller.addEventListener("click", function () {
      const dongCode = element.dongCode;
      const dongTermSimple = element.dongTermSimple;
      const elderTerm = element.userTerm;
      const elderId = element.userId;
      const startDtm = new Date();
      const endDtm = new Date();
      const radio = "HH";

      history.push({
        pathname: "/log/elder",
        state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
      });
    });
  };

  // 카카오 맵의 마커를 제어 (삭제)
  const removeMarkers = () => {
    for (let i = 0; i < markers.current.length; i++) {
      markers.current[i].setMap(null);
    }
    // 저장된 마커 전부 초기화
    if (search.dongCode === "") {
      markers.current = [];
    }
  };

  // 맵 좌표 요청 (맵 이동)
  const setMapPosition = (lati, longi, map) => {
    if (map) {
      if (!lati) {
        lati = DEFAULT_LATI;
      }
      if (!longi) {
        longi = DEFAULT_LONGI;
      }
      map.setCenter(new kakao.maps.LatLng(lati, longi));
    }
  };

  const initSearch = () => {
    search.userId = "";
    search.meainStatCode = "";
    search.dongCode = getUser().userTypeCode === 2002 ? getUser().dongCode : "";
    search.lati = DEFAULT_LATI;
    search.longi = DEFAULT_LONGI;
    search.mapLevel = DEFAULT_MAP_LEVEL;
    search.mapAddressCode = "";
    search.cityProvCode = "";
    search.cityProvTerm = "";
    search.mapLevelTerm = "전체 시도별";
    search.type = AREA_CITY;
    search.dong = { dongCode: "", dongTermSimple: "읍면동" };
    search.bizType = "";
    search.dangerElderYn = "";
  };

  useEffect(() => {
    // 데이터 불러오기
    if (isUser()) {
      alert("권한이 없습니다.");
      history.push("/");
    }

    if(history.location.state){
      loadMap(history.location.state.lati, history.location.state.longi, history.location.state.dongCode);
    }else{
      loadMap(DEFAULT_LATI, DEFAULT_LONGI, '');
    }
  }, []);

  return (
    <div
      className="MapBoxBg"
      style={
        loading
          ? {
              opacity: 0.6,
              pointerEvents: "none",
              position: "relative",
            }
          : null
      }>
      <ElderInfoList
        conn={conn}
        styles={styles}
        map={map}
        elderInfoList={dataSource}
        dongList={dongList}
        search={search}
        setSearch={setSearch}
        getInfoData={getInfoData}
        initSearch={initSearch}
        defaultLati={DEFAULT_LATI}
        defaultLongi={DEFAULT_LONGI}
        loadMap={loadMap}
        history={history}
      />
      <span className="MapRightBg">
        <div id="locaitonMap" style={{ width: "100%", height: "100%" }}></div>
      </span>
      {loading && (
        <p
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            zIndex: 9999,
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </div>
  );
};
export default InstallStatus;
